import { render, staticRenderFns } from "./Technician.vue?vue&type=template&id=46b97655&scoped=true&"
var script = {}
import style0 from "./Technician.vue?vue&type=style&index=0&id=46b97655&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b97655",
  null
  
)

export default component.exports